import Operation from './Operation'
import CurrencySelect from './CurrencySelect'
import BankAccount from './BankAccount'
import Confirmation from './Confirmation'

export default class Payment {
  constructor(component) {
    this.component = component
  }
  name() {
    return 'payment'
  }
  handle(event) {
    if(event.back) {
      this.component.modalExpanded = false
      switch(this.component.selected_operation) {
        case 'pay':
        case 'receive':
          this.component.transaction_controller = new BankAccount(this.component)
          break
        case 'deposit':
        case 'fee_payoff':
        case 'exchange_internal':
          this.component.transaction_controller = new CurrencySelect(this.component)
          break
        default:
          this.component.transaction_controller = new Operation(this.component)
      }
      return
    }
    if (event.createTransaction) {
      this.component.selected_from_bank_account = event.from_bank_account
      this.component.selected_value = event.value
      this.component.selected_exchanged_value = event.exchanged_value
      this.component.reverse_exchange = event.reverse_exchange
      this.component.selected_payment_method = event.payment_method
      this.component.selected_from_currency = event.fromCurrency
      this.component.selected_to_currency = event.toCurrency
      this.component.exchange_under_request = event.exchange_under_request
      if (event.selected_bank_account) {
        this.component.selected_bank_account = event.selected_bank_account
      }
      if (event.selected_subject) {
        this.component.selected_subject = event.selected_subject
      }
      this.component.modalExpanded = false
      this.component.transaction_controller = new Confirmation(this.component)
      return
    }
  }
}




// WEBPACK FOOTER //
// ./src/controllers/NewTransaction/Payment.js